import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwipeableComponent } from './swipeable/swipeable.component';
import { PortalModule } from '@angular/cdk/portal';

@NgModule({
  declarations: [SwipeableComponent],
  exports: [SwipeableComponent],
  imports: [CommonModule, PortalModule],
})
export class SwipeableModule {}
